const parseFlag = (value: string | undefined): boolean => value === 'true';

export const FEATURE_FLAGS = {
  ARBITRAGE: parseFlag(import.meta.env.VITE_FEATURE_ARBITRAGE),
};
